module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0006_06_B18_1.75ca534.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0006_06_B18_1.jpg
// module id = 5ips
// module chunks = 0